import React, { useCallback, useEffect, useState } from 'react';
import Row from 'components/Common/Row';
import EntityResults from '../SearchResults/EntityResults';
import ActiveFilterToggle from '../ActiveFilterTogle';
import FilterBy from './FilterBy';
import Button from '../../../../kingpin/atoms/Button';

const useResults = ({
  result,
  selectedEntity,
}: {
  result: GlobalSearch.SearchResults;
  selectedEntity: EntityDetails.Entity;
}) => {
  const getResults = useCallback(() => {
    const newResult = result.results.find(
      (r) => r.entity.id === selectedEntity.id,
    );
    if (!newResult) {
      const e = new Error();
      e.name = 'Entity results not found';
      throw e;
    }
    return newResult;
  }, [result.results, selectedEntity.id]);

  const [results, setResults] = useState<GlobalSearch.Result>(getResults);

  useEffect(() => {
    setResults(getResults());
  }, [getResults]);

  return results;
};

const EntitySearchResults = ({
  result,
  onEntityNavigate,
  selectedEntity,
  setSelectedEntity,
  isActiveFilterDisabled,
  setIsActiveFilterDisabled,
}: {
  result: GlobalSearch.SearchResults;
  onEntityNavigate: (entity: EntityDetails.Entity) => void;
  selectedEntity: EntityDetails.Entity;
  setSelectedEntity: React.Dispatch<
    React.SetStateAction<EntityDetails.Entity | undefined>
  >;
  isActiveFilterDisabled: boolean;
  setIsActiveFilterDisabled: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const entityResults = useResults({ result, selectedEntity });
  const onBackClicked = useCallback(() => {
    setSelectedEntity(undefined);
  }, [setSelectedEntity]);

  return (
    <div>
      <div style={{ margin: 16, width: 'fit-content' }}>
        <div onClick={onBackClicked}>
          <Button
            label="Back to all search results"
            icon="arrow-left"
            type="Secondary"
            size="Small"
          />
        </div>
      </div>
      <div style={{ margin: 16 }}>
        <Row spaceBetween centerAlign>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            <div
              style={{
                color: 'var(--color-text-muted)',
                fontStyle: 'italic',
                fontSize: 14,
              }}
            >
              {`Showing results for "${entityResults.searchText}"`}
            </div>
          </div>
          <Row centerAlign>
            <div style={{ marginRight: 16 }}>
              <FilterBy
                selectedEntity={selectedEntity}
                onRemoveClicked={onBackClicked}
              />
            </div>
            <ActiveFilterToggle
              isActiveFilterDisabled={isActiveFilterDisabled}
              setIsActiveFilterDisabled={setIsActiveFilterDisabled}
            />
          </Row>
        </Row>
      </div>
      <EntityResults
        result={entityResults}
        onEntityNavigate={onEntityNavigate}
        isShowingFirstFour={false}
        setSelectedEntity={setSelectedEntity}
      />
    </div>
  );
};

export default EntitySearchResults;
